import { CardShell } from './CardShell';

export type RankingRow = {
  node?: string; Node?: string;
  node_id?: string; NodeID?: string;   // 后端 SLARecord 真身
  count?: number; Count?: number;
  timeout_count?: number; TimeoutCount?: number;
};

const pickS = (d: RankingRow, ...ks: string[]): string => {
  for (const k of ks) {
    const v = (d as Record<string, unknown>)[k];
    if (typeof v === 'string' && v) return v;
  }
  return '';
};
const pickN = (d: RankingRow, ...ks: string[]): number => {
  for (const k of ks) {
    const v = (d as Record<string, unknown>)[k];
    if (typeof v === 'number') return v;
  }
  return 0;
};

export function RankingCard({
  items, source = 'ai', onRowClick,
}: {
  items: RankingRow[];
  source?: 'ai' | 'page';
  onRowClick?: (row: RankingRow) => void;
}) {
  const list = (Array.isArray(items) ? items : []).slice(0, 10);
  const max = Math.max(1, ...list.map(r => pickN(r, 'count', 'Count', 'timeout_count', 'TimeoutCount')));
  return (
    <CardShell title="SLA 超时排行" source={source}>
      {list.map((r, i) => {
        const node = pickS(r, 'node', 'Node', 'node_id', 'NodeID') || '未知节点';
        const count = pickN(r, 'count', 'Count', 'timeout_count', 'TimeoutCount');
        return (
          <div
            key={node + i}
            onClick={() => onRowClick && onRowClick(r)}
            style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 0', fontSize: 13, cursor: onRowClick ? 'pointer' : 'default' }}
          >
            <span style={{ width: 18, color: '#9ca3af' }}>{i + 1}</span>
            <span style={{ width: 110, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{node}</span>
            <div style={{ flex: 1, height: 10, background: '#f3f4f6', borderRadius: 5, overflow: 'hidden' }}>
              <div style={{ width: `${(count / max) * 100}%`, height: '100%', background: '#f59e0b', borderRadius: 5 }} />
            </div>
            <span style={{ width: 30, textAlign: 'right', color: '#6b7280' }}>{count}</span>
          </div>
        );
      })}
      {list.length === 0 && <div style={{ color: '#9ca3af', fontSize: 12 }}>暂无数据</div>}
    </CardShell>
  );
}
